import React from "react";
import { RankingPlayer } from "types/ranking";
import { getAvatarImage } from "utils/avatars";
import "./styles.scss";

// Importar imagens das placas de tesouro
import placaDourada from "assets/img/placa_tesouro_dourada.png";
import placaPrata from "assets/img/placa_tesouro_prata.png";
import placaBronze from "assets/img/placa_tesouro_bronze.png";
import bgVideo from "assets/video/bg_tesouro.mp4";

interface BannerPodiumTreasureProps {
  title?: string;
  players: RankingPlayer[];
  isLoading?: boolean;
}

export const BannerPodiumTreasure: React.FC<BannerPodiumTreasureProps> = ({
  title = "Top 3",
  players,
  isLoading = false,
}) => {
  // Garantir que temos exatamente 3 jogadores (preenchendo com vazios se necessário)
  const topThree = [...players];
  while (topThree.length < 3) {
    topThree.push({
      id: `empty-${topThree.length}`,
      name: "---",
      position: topThree.length + 1,
      points: 0,
    });
  }

  // Ordenar: 2º, 1º, 3º (ordem visual do pódio)
  const [first, second, third] = topThree.slice(0, 3);
  const podiumOrder = [second, first, third];

  const getTreasurePlateImage = (position: number): string => {
    switch (position) {
      case 1:
        return placaDourada;
      case 2:
        return placaPrata;
      case 3:
        return placaBronze;
      default:
        return placaDourada;
    }
  };

  const getPlayerInitials = (name: string): string => {
    if (!name || name === "---") return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  if (isLoading) {
    return (
      <div className="top3-treasure-podium">
        <video className="ranking-bg-video" autoPlay loop muted playsInline>
          <source src={bgVideo} type="video/mp4" />
        </video>
        <div className="treasure-podium-container relative -mt-[332px]">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Carregando ranking...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="top3-treasure-podium">
      <video className="ranking-bg-video" autoPlay loop muted playsInline>
        <source src={bgVideo} type="video/mp4" />
      </video>
      <div className="treasure-podium-container relative -mt-[332px]">
        {podiumOrder.map((player, index) => {
          const avatarSrc =
            getAvatarImage(player.fotoDePerfil || player.avatar) ||
            getAvatarImage(player.avatar);
          const isFirstPlace = player.position === 1;

          return (
            <div
              key={player.id}
              className={`treasure-plate-item ${isFirstPlace ? "first-place" : ""}`}
            >
              <div className="plate-wrapper">
                <div className="position-number">{player.position}</div>
                <img
                  src={getTreasurePlateImage(player.position)}
                  alt={`${player.position}º Lugar`}
                  className="treasure-plate-image"
                />
                <div className="player-overlay">
                  <div className="player-avatar-container">
                    {avatarSrc ? (
                      <img
                        src={avatarSrc}
                        alt={player.name}
                        className="player-avatar-img"
                      />
                    ) : (
                      <div className="player-avatar-placeholder">
                        {getPlayerInitials(player.name)}
                      </div>
                    )}
                  </div>
                  <div className="player-info">
                    <div className="name-ribbon">
                      <h3 className="player-name">{player.name}</h3>
                    </div>
                    <p className="player-points">
                      {player.points.toLocaleString("pt-BR")} pts
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
